import { Suspense } from "react";
import { AuthProvider } from "common/providers/AuthProvider";
import { LoadingProvider } from "common/providers/LoadingProvider";
import { AlertsProvider } from "common/providers/alerts";
import { ParkProvider } from "common/providers/ParkProvider";
import { AnimalProvider } from "common/providers/AnimalProvider";
import { SocketProvider } from "common/providers/socket/SocketProvider";
import { AppConfigProvider } from "common/providers/AppConfigProvider";

type Props = {
  children: JSX.Element;
};

function AppProvider({ children }: Props) {
  return (
    <Suspense>
      <AppConfigProvider>
        <LoadingProvider>
          <AlertsProvider>
            <ParkProvider>
              <AuthProvider>
                <AnimalProvider>
                  <SocketProvider>{children} </SocketProvider>
                </AnimalProvider>
              </AuthProvider>
            </ParkProvider>
          </AlertsProvider>
        </LoadingProvider>
      </AppConfigProvider>
    </Suspense>
  );
}

export default AppProvider;
